import { render, staticRenderFns } from "./ocft.vue?vue&type=template&id=9c79e2e4&scoped=true&"
import script from "./ocft.vue?vue&type=script&lang=js&"
export * from "./ocft.vue?vue&type=script&lang=js&"
import style0 from "./ocft.vue?vue&type=style&index=0&id=9c79e2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c79e2e4",
  null
  
)

export default component.exports